import { languageOptions } from "pages/common/Settings/components/YourDetails/options";

const VALID_APP_LOCALES = new Set(["en", "de", "es", "fr", "kr", "ja", "th", "pt-br", "zh-cn"]);

/**
 * Maps API/user language values to app locale codes used by IntlProvider.
 * The API may return display labels (e.g. "Japanese - 日本人") instead of codes (e.g. "ja").
 */
function resolveAppLocale(language) {
  if (!language || language === "undefined") {
    return "en";
  }

  const normalized = String(language).trim();

  if (VALID_APP_LOCALES.has(normalized)) {
    return normalized;
  }

  const byLabel = languageOptions.find((option) => option.label === normalized);
  if (byLabel) {
    return byLabel.value;
  }

  const englishName = normalized.split(" - ")[0];
  const byEnglishName = languageOptions.find((option) => option.label.startsWith(englishName));
  if (byEnglishName) {
    return byEnglishName.value;
  }

  return "en";
}

export { resolveAppLocale, VALID_APP_LOCALES };
